// Module
var code = `<div class="campaign-status" ng-if="campaignStatusCtrl.showCampaignStatus" ng-class="campaignStatusCtrl.campaignStatus"> <span class="campaign-status__indicator"></span> <span class="campaign-status__label">{{ "CAMPAIGN" | translate }}: {{ campaignStatusCtrl.campaignStatusLabel | translate}}</span> </div>`;
// Exports
export default code;